import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { Link } from "gatsby"

import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/expph/herolp.jpg"

const HomePage = () => {



    return (
        <>
            <Seo
                title="Home"
                description="UK's Leading Luxury Architectural &amp; Interior Design Firm"
                image={im1}
            />



            <div className="section">

                <StaticImage placeholder="dominantColor" className="image maxdim" src="../images/expph/herolp.jpg" alt="herolp" />
            </div>



            <div className="section flexthis">

                <div className="flex3 centerthis servicesmobile">
                    <article className="article">
                        <h3>
                            Services
                            <br />
                            I Provide
                        </h3>
                        <p>
                            People in places is our game at Nolan Interiors. The best locations, in my opinion, are completely unique and
                            reflect you or your company. Nolan Interiors places a premium on utility, comfort, and aesthetics, which we achieve using traditional design techniques and an artistic
                            approach to composition. I start with research and inspiration and work my way through the design stages to discover the most
                            efficient, useful, and elegant solution for you.
                        </p>
                    </article>
                </div>

                <div className="flex5">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/expph/residential.jpg" alt="herolp" />
                </div>

            </div>


            {/* <!--Portfolio--> */}
            <div className="section">
                <h3 className="centerthis">SELECTED PROJECTS</h3>
            </div>

            <div className="section">

                <div className="portfoliogrid">
                    <Link to="/ocean-overlook">
                        <StaticImage placeholder="dominantColor" className="image" src="../images/bh/h3.jpg" alt="herolp" />
                    </Link>
                    <Link to="/cafe-mania">
                        <StaticImage placeholder="dominantColor" className="image" src="../images/caf/h4.jpg" alt="caf" />
                    </Link>
                    <Link to="/cool-office" className="span2">
                        <StaticImage placeholder="dominantColor" className="image" src="../images/of/h4.jpg" alt="herolp" />
                    </Link>
                    <Link to="/wooden-castle">
                        <StaticImage placeholder="dominantColor" className="image" src="../images/wd/h5.jpg" alt="herolp" />
                    </Link>
                    <Link to="/white-villa">
                        <StaticImage placeholder="dominantColor" className="image" src="../images/wv/h5.jpg" alt="herolp" />
                    </Link>
                </div>

            </div>


            {/* <!--Glorified Break tag--> */}
            <div className="section"><br /></div>


            {/* <!--About ME--> */}
            <div className="section flexthis">
                <div className="flex5 aboutimage">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/expph/l2.jpg" alt="herolp" />
                </div>

                <div className="flex3 centerthis designimage">
                    <article className="article">
                        <h3>About Me</h3>
                        <p>Stacy Nolan has been running her own design firm for almost 27 years. The studio focuses on residential and commercial design, primarily in London but also internationally. Her art has been featured in the British press several times.
                            Stacy has a degree in architecture.</p>
                    </article>
                </div>

            </div>

            {/* <!--Glorified Break tag--> */}
            <div className="section"><br /></div>

            {/* <!--Design Philosophy--> */}

            <div className="section">

                <h3 className="centerthis">DESIGN PHILOSOPHY</h3>

                <div className="designflex">

                    <div className="philosophygrid">
                        <div>
                            {/* <!--blank space--> */}
                        </div>
                        <div className="centerthis">
                            <p className="article">Our environments have the power to change people's lives. I create surroundings
                                that are unique and ageless, stimulating all of the senses, by going beyond trend. I comprehend a
                                project's ultimate essence, which reveals the true design storey.</p>
                        </div>
                        <div className="black margintopbottom">
                            {/* <!--horizontal line--> */}
                        </div>
                        <div className="centerthis">
                            <p className="article">My vision is ambitious, far-ranging and constantly innovating. Guided by clear style
                                principles yet unfettered by a house ‘style’, I always see beyond the bounds of a brief to discover
                                surprising and inspiring possibilities.</p>
                        </div>
                        <div>
                            {/* <!--blank space--> */}
                        </div>

                    </div>
                    <StaticImage placeholder="dominantColor" className="image halfdim designimage" src="../images/expph/test.jpg" alt="herolp" />

                </div>
            </div>

            {/* <!--Testimonials--> */}

            <div className="section blackmobile margintopbottom">
                {/* <!--horizontal line only mobile--> */}
            </div>

            <h3 className="centerthis">OUR 3 STEP PROCESS</h3>
            <div className="testimonialgrid">
                
                <div className="centerthis margintopbottom">
                    {/* <h3>Assment</h3> */}
                    <article className="article">
                        <h4>ASSESSMENT</h4>
                        <p>The assessment phase of your project is all about discovering what home means to you. Whether you’re a proud parent of four, a newlywed couple just starting out, or a seasoned homeowner who’s reached a point where it feels like their space is lacking character — we’ll uncover the little things that make your home feel warm and welcoming and leave no stone unturned in creating an environment that reflects your lifestyle.</p>
                        
                    </article>

                </div>
                <div className="centerthis margintopbottom">
                    <article className="article">
                        <h4>CREATION</h4>
                        <p>The Creation Phase is where we and our experienced design team start building your dream home. This is where the magic happens and we turn your vision into a reality with meticulous attention to detail, ensuring your home is both a haven of relaxation and a place to entertain friends and family. </p>
                        
                    </article>
                </div>
                <div className="centerthis margintopbottom">
                    <article className="article">
                        <h4>IMPLEMENTATION</h4>
                        <p>We work together to create a bespoke space that reflects who you are and how you live. Our team will help you with everything from big purchases to small tweaks, so your newly organized home is exactly what you wanted it to be. It’s our way of making sure you love your new space as much as we do!</p>
                       
                    </article>
                </div>
                {/* <div className="centerthis margintopbottom">
                    <article className="article">
                        <p>" Working with the Nolan Interiors team, is working with glamour, responsibility, and commitment. They will work with your needs and help you going through the transition of renovating your home. "</p>
                        <h4>Ms. Naira Teguya</h4>
                    </article>
                </div> */}


            </div>

            {/* <!--PRESS MENTIONS-->

            <div className="section blackmobile margintopbottom">
                <!--horizontal line only mobile-->
            </div>

            <div className="section">
                <h3 className="centerthis">PRESS MENTIONS</h3>
            </div>

            <div className="testimonialgrid">
                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f1.png" alt="logo" />
                </div>

                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f2.png" alt="logo" />
                </div>

                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f3.png" alt="logo" />
                </div>

                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f4.png" alt="logo" />
                </div>

                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f5.png" alt="logo" />
                </div>

                <div className="centerthis">
                    <StaticImage placeholder="dominantColor" className="image logo" src="../images/logos/f6.png" alt="logo" />
                </div>

            </div> */}


            {/* footer */}

            <div className="section flexthis">

                <div className="">
                    <StaticImage placeholder="dominantColor" className="image contact" src="../images/expph/pic1.jpg" alt="herolp" />
                </div>

                <div className="centerthis servicesmobile mobilemargins">
                    <article className="article">
                        <h3>I WOULD LOVE <br />TO TALK </h3>
                        <p>Want to talk with me about designing your home? Ah-mazing. I totally want to talk to YOU. Drop us a line!</p>
                        <h3>
                            <a href="mailto:hello@nolaninteriors.com">hello@nolaninteriors.com</a>
                        </h3>
                        <form action="">
                            <input type="text" placeholder="NAME" />
                            <input type="text" placeholder="EMAIL" />
                            <input type="text" placeholder="CONTACT NO." />
                            <input type="text" placeholder="REFERENCE" />
                            <textarea name="" id="" cols="30" rows="10" />
                            <button className="button">SUBMIT</button>
                        </form>

                        <div className="flexthis">
                            <a href="https://facebook.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">facebook</a>
                            <a href="https://www.instagram.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">instagram</a>
                            <a href="https://pinterest.com/nolaninteriors/" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">pinterest</a>
                            <a href="https://www.houzz.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">houzz</a>
                        </div>

                        <div className="flexthis">
                            <a href="https://asteriasoft.studio" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">Website by Asteriasoft</a>
                        </div>
                    </article>
                </div>
            </div>

        </>
    )
}

export default HomePage




